import type { MagicLinkFailureReason } from './adminMagicLink';

export const CUSTOMER_MAGIC_LINK_EXPIRED_MESSAGE = 'This access link has expired.';
export const CUSTOMER_MAGIC_LINK_USED_MESSAGE = 'This access link has already been used.';
export const CUSTOMER_MAGIC_LINK_INVALID_MESSAGE = 'This access link is invalid.';

/**
 * Whether ProjectPage should show the click-to-continue gate for a URL token (IS-1697).
 */
export function shouldPromptCustomerTokenContinue(
  token: string | null,
  tokenConsumed: boolean
): boolean {
  return Boolean(token && !tokenConsumed);
}

/**
 * Maps verifyMagicLink HTTP response to an error message, or null on success.
 */
export function getCustomerTokenVerificationError(
  responseOk: boolean,
  result: { success?: boolean; error?: string; reason?: MagicLinkFailureReason }
): string | null {
  if (responseOk && result.success) {
    return null;
  }

  if (result.reason === 'used') {
    return CUSTOMER_MAGIC_LINK_USED_MESSAGE;
  }
  if (result.reason === 'invalid') {
    return CUSTOMER_MAGIC_LINK_INVALID_MESSAGE;
  }
  if (result.reason === 'expired') {
    return CUSTOMER_MAGIC_LINK_EXPIRED_MESSAGE;
  }

  return result.error || CUSTOMER_MAGIC_LINK_EXPIRED_MESSAGE;
}
